// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__YJB7y","col":"styles_col__1GtaM"};